import { render, staticRenderFns } from "./AwardDetails.vue?vue&type=template&id=5b7f87a4&"
import script from "./AwardDetails.vue?vue&type=script&lang=js&"
export * from "./AwardDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports